import { Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'app-utilities',
  templateUrl: './utilities.component.html',
  styleUrls: ['./utilities.component.scss']
})
export class UtilitiesComponent implements OnInit {

  @Input() isRupeeVisible: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
